var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./SingleLoanPaymentRecords.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-45901de3!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./SingleLoanPaymentRecords.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/microfinance/components/SingleLoanPaymentRecords.vue
// module id = 767
// module chunks = 0